import styled from "styled-components";
import { Column, Line } from "../../style";
import { borderColors, primary } from "../../theme";
import { IThemeProps, themeTypes } from "../../interfaces";

export const GroupTitle = styled.div`
    align-items: center;
    margin-top: 20px;
    margin-bottom: -10px;
    font-weight: 600;
`

export const FieldsLine = styled(Line)`
    gap: 20px;
    flex-wrap: wrap;
`

export const ContainerBlock = styled(Column) <IThemeProps>`
    border-radius: 5px;
    background: ${(props) => primary[props.theme as themeTypes]};
    border: 1px solid ${(props) => borderColors[props.theme as themeTypes]};
    margin-bottom: 20px;
`

export const ContainerGroups = styled(Column)`
  gap: 20px;
  padding: 20px;
`;


export const HeaderGroup = styled(Line)`
  gap: 10px;
  padding: 10px;
  padding-left: 20px;
  align-items: center;
  display: flex;
  border-bottom: 1px solid ${(props) => borderColors[props.theme as themeTypes]};
`;

export const DescriptionGroup = styled.div`
  font-size: 13px;
  margin-top: -5px;
`;

export const TitleGroup = styled.div`
  font-size: 14px;
  font-weight: 600;
`;

export const ContainerForm = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`